import { render } from "./VoteComment.vue?vue&type=template&id=5ff79c49&scoped=true"
import script from "./VoteComment.vue?vue&type=script&lang=js"
export * from "./VoteComment.vue?vue&type=script&lang=js"

import "./VoteComment.vue?vue&type=style&index=0&id=5ff79c49&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff79c49"]])

export default __exports__